<template>
  <div>
    <vs-prompt
      title="Select version"
      @accept="acceptVersion"
      :active.sync="versionPopupActive"
      accept-text="View version"
      :is-valid="!!selectedVersion"
    >
      <vs-row v-if="versionPopupActive">
        <vs-col vs-w="12">
          <vs-select v-if="versions" label="Version" class="w-full" v-model="selectedVersion">
            <vs-select-item
              :key="item.id"
              :value="item"
              :text="versionLabel(item)"
              v-for="item in sortedVersions"
            />
          </vs-select>
        </vs-col>
      </vs-row>
    </vs-prompt>

    <vx-card no-shadow>
      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-4/5 w-full">
          <vs-row>
            <h2 style="font-size: revert; font-weight: 500">
              {{ template.title }}
            </h2>
            <a
              :style="{ color: isNewestVersion ? '#7367f0' : '#eb5959' }"
              @click="openVersionPopup"
              class="cursor-pointer ml-2 mt-1"
            >(Version {{ template.version }} - {{ isNewestVersion ? "Newest" : "Not newest" }})</a>
          </vs-row>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <vs-input :disabled="!isEditable" v-model="template.title" class="w-full" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Description</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <vs-textarea :disabled="!isEditable" v-model="template.description" rows="4" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Country</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <code>{{ template.country }}</code>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="template.savedAction">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Last updated</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <span>{{ template.savedAction.timestamp | formatDate }} by {{ template.savedAction.userDisplayName }}</span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>This version is</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <code>{{ template.isPublished ? "Published" : "Not published" }}</code>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Versions</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <code>{{ versions.length }} versions</code>
        </div>
      </div>

      <vs-row vs-justify="space-between" class="flex flex-wrap items-center mt-6">
        <vs-button color="warning" v-if="isEditable" @click="$emit('publish')">Publish</vs-button>
        <vs-button v-else-if="template.isPublished" @click="$emit('new-version')">Create new version</vs-button>
        <vs-button color="success" v-if="isEditable" @click="$emit('save')">Save</vs-button>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

export default {
  props: {
    template: { type: Object, required: true },
    versions: { type: Array, default: function () { return []; } },
    isEditable: { type: Boolean, default: false },
  },
  data: function () {
    return {
      versionPopupActive: false,
      selectedVersion: null,
    };
  },
  computed: {
    sortedVersions: function () {
      var copy = this.versions.slice();
      copy.sort(function (a, b) { return b.version - a.version; });
      return copy;
    },
    newestPublishedVersion: function () {
      if (!this.versions || this.versions.length === 0) return 0;
      var published = this.versions.filter(function (e) { return e.isPublished; });
      var max = _.maxBy(published, "version");
      return max ? max.version : 0;
    },
    maxVersion: function () {
      if (!this.versions || this.versions.length === 0) return 0;
      var max = _.maxBy(this.versions, "version");
      return max ? max.version : 0;
    },
    isNewestVersion: function () {
      return this.template.version === this.maxVersion;
    },
  },
  methods: {
    openVersionPopup: function () {
      this.selectedVersion = null;
      this.versionPopupActive = true;
    },
    versionLabel: function (item) {
      var label = "Version " + item.version;
      if (item.version === this.newestPublishedVersion) {
        label += " - newest published";
      }
      if (item.createdAction && item.createdAction.timestamp) {
        label += " (" + moment(item.createdAction.timestamp).format("DD/MM/YYYY HH:mm") + ")";
      }
      return label;
    },
    acceptVersion: function () {
      if (this.selectedVersion) {
        this.$emit("select-version", this.selectedVersion.id);
      }
    },
  },
};
</script>
